<script>
    export let data;
</script>

<style></style>

<ul class="list-disc">
  <li class="list-inside p3 py-xs">{data.text}</li>
</ul>
